import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=45d3973c"
import script from "./Contracts.js?vue&type=script&lang=js&external"
export * from "./Contracts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports